import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OrderSuccess = () => {
  return (
    <div className="min-h-screen py-24 px-6" data-testid="order-success-page">
      <div className="max-w-2xl mx-auto text-center">
        <CheckCircle className="w-20 h-20 text-[#2E4A3B] mx-auto mb-6" data-testid="success-icon" />
        <h1 className="text-5xl font-heading font-bold text-[#1F2937] mb-4" data-testid="success-heading">
          Order Confirmed!
        </h1>
        <p className="text-xl text-[#5D5C56] mb-8" data-testid="success-message">
          Thank you for your order! We'll contact you shortly with payment and delivery details.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/shop" data-testid="continue-shopping-link">
            <button className="btn-primary">
              Continue Shopping
            </button>
          </Link>
          <Link to="/" data-testid="home-link">
            <button className="btn-outline">
              Back to Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;